import {isArray, isEmpty, isObject} from "lodash";
import {constructFilter, destructFilter} from "./AdvancedFilterApiUtils";

function validFilterObject(filter) {
  if (isEmpty(filter)) {
    return false
  }

  const keysNumber = Object.keys(filter).length;
  if (keysNumber < 2 || keysNumber > 3) {
    return false
  }

  if (!filter.hasOwnProperty("name") || !filter.hasOwnProperty("operator")) {
    return false;
  }

  if (isEmpty(filter.name)) return false;
  return !isEmpty(filter.operator);
}

export function constructSort(sort, defaultSort) {
  const sorts = [];
  if (sort && Object.keys(sort).length > 0) {
    const [key, direction] = Object.entries(sort)[0];
    // console.log("key", key, "direction", direction);
    sorts.push({name: key, direction: direction})
  }
  if (defaultSort) {
    defaultSort = Array.isArray(defaultSort) ? defaultSort : [defaultSort];
    defaultSort.forEach(s => sorts.push({name: s.name, direction: s.direction}));
  }

  return sorts.filter(({direction}) => direction === "asc" || direction === "desc")
    .reduce(([sortString, delimiter], {name, direction}) => ([sortString + delimiter + encodeURI(name + "," + direction), "&sort="]), ["", "sort="])[0];
}

export function destructSort(sortString) {
  if (!sortString || sortString.trim() === "") {
    return {};
  }

  // Remove the initial 'sort=' prefix if present
  sortString = sortString.replace(/^sort=/, "");

  // Split the sort string into individual sort fields
  const sorts = sortString.split("&sort=");

  // Reduce the array of sorts into an object
  return sorts.reduce((result, sort) => {
    const [name, direction] = sort.split(",");
    result[name] = direction;
    return result;
  }, {});
}

export function addDefaultSort(sort, defaultSort) {
  return constructSort(destructSort(sort), defaultSort);
}

export function constructPage(page, pageSize) {
  if (isNaN(page) || isNaN(pageSize)) {
    return "";
  }
  return "page=" + page + "&size=" + pageSize;
}

export function destructPage(pageString) {
  if (isEmpty(pageString)) {
    return undefined;
  }
  pageString = pageString.replace(/^page=/, "");
  const [page, pageSize] = pageString.split("&size=");
  return {page: parseInt(page), size: parseInt(pageSize)};
}

export function constructParameters(page, filter, sort) {
  if (isObject(page)) {
    page = constructPage(page.page, page.size);
  }
  if (isArray(filter)) {
    filter = constructFilter(filter);
  }

  if (isObject(sort)) {
    sort = constructSort(sort);
  }
  return [page, filter, sort].filter(item => !!item).join("&");
}
export function destructParameters(parameters) {
  const [pageStr, filterStr, sortStr] = parameters.split("&");
  const page = destructPage(pageStr);
    const filter = destructFilter(filterStr);
    const sort = destructSort(sortStr);
  return {page: page, filter: filter, sort: sort};
}
